module.exports = __webpack_public_path__ + "img/icon_5_20.f69581dc.png";